import BlSliderIndicatorAv from './BlSliderIndicatorAv.vue'

BlSliderIndicatorAv.install = function(Vue) {
  Vue.component(BlSliderIndicatorAv.name, BlSliderIndicatorAv)
}

export default BlSliderIndicatorAv
